import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  DetailList,
  Chip,
} from '@forgeglobal/design-framework';
import kebabCase from 'lodash/kebabCase';
import Spinner from '@tcs/common/components/atoms/Spinner';
import { useStyles } from './style';

export { default as DetailCardItem } from './DetailCardItem';

interface Props {
  title: string;
  action?: React.ReactNode;
  children?: React.ReactNode;
  loading?: boolean;
  chipLabel?: string;
}

const DetailCard = ({ title, action, children, loading, chipLabel }: Props) => {
  const classes = useStyles();
  return (
    <Card data-test-id={kebabCase(title)}>
      <CardHeader
        title={
          <div className={classes.headerWrapper}>
            <span className={classes.headerText}>{title}</span>
            {chipLabel && <Chip label={chipLabel} />}
          </div>
        }
        action={action}
        className={classes.cardHeader}
      />
      <CardContent surface="light" className={classes.cardContent}>
        <DetailList>
          {loading ? (
            <div className={classes.loading}>
              <Spinner size="small" />
            </div>
          ) : (
            children
          )}
        </DetailList>
      </CardContent>
    </Card>
  );
};

export default DetailCard;
